import * as React from 'react';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Button, Stack } from '@mui/material';
import { Box } from '@mui/system';
import { useDispatch, useSelector, } from 'react-redux';
import ViewImage from '../../../../../components/ViewImage';
import { submitConfirmPaymentInvoice } from '../redux/invoicesReducers';
import { RootState } from '../../../../../app/store';
import { checkValidation } from '../../../../../utilities/userFeaturesValidation';

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
  },
  '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
  },
}));

export interface DialogTitleProps {
  id: string;
  children?: React.ReactNode;
  onClose: () => void;
}

const BootstrapDialogTitle = (props: DialogTitleProps) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

const DialogConfirm : React.FC<any> = ({ open, setOpen, infoPayment, setFileUrl  }) => {

    const { approve_payment} = useSelector((state : RootState) => state.invoice)

    const dispatch = useDispatch()
    const [openView, setOpenView] = React.useState(false);

    const { _id, fileUrl : urlImg } = infoPayment.length && infoPayment.slice(-1).pop()

    function handleClose () {
        setOpen(false);
        setFileUrl({name : '', url: '', type: 'upload'})
    };

    React.useEffect(() => {
      if(approve_payment){
        setOpen(false)
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [approve_payment]);
    
    return (  
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth={true}
        maxWidth="sm"
      >
        <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
           <Stack flexDirection="row" justifyContent="center">
                <Box pt={1} fontWeight="bold">Confirm Payment Proof</Box>
           </Stack>
        </BootstrapDialogTitle>
        <DialogContent dividers >
          <Box className="proofpayment">
            { urlImg === undefined ? 
            null
            :
            <Stack flexDirection="column" className='image-preview' >
              <img alt="file" src={urlImg} onClick={()=> setOpenView(true)} />
            </Stack> }
          </Box> 
        </DialogContent>
        <DialogActions>
          { checkValidation('CONPAYINV4312341') &&
          <Button 
            color="primary"
            size="small" autoFocus variant='contained' 
            disabled={urlImg === undefined ? true : false}
            onClick={() => dispatch(submitConfirmPaymentInvoice(_id))}
          >
            Confirm Payment
          </Button> }
        </DialogActions>
      </BootstrapDialog>
      <ViewImage open={openView} setOpen={setOpenView} url={urlImg && urlImg} />
    </div>
  );
}

export default DialogConfirm;